import Usertable from '../../components/userTable/Usertable'
import './users.scss'

const Users = () => {
  return <Usertable />
}

export default Users
